export enum ImageSize {
    FULL_SCREEN_PHOTO = 'FULL_SCREEN_PHOTO',
    NORMAL_PHOTO = 'NORMAL_PHOTO',
}
